
interface FilterResultsSummaryProps {
  selectedState: string;
  selectedCrop: string;
  selectedCommunity: string;
  filteredTopicsCount: number;
}

export const FilterResultsSummary = ({
  selectedState,
  selectedCrop,
  selectedCommunity,
  filteredTopicsCount
}: FilterResultsSummaryProps) => {
  const hasFilters = selectedState !== "All States" || 
                    selectedCrop !== "All Crops" || 
                    selectedCommunity !== "All Communities";

  if (!hasFilters) return null;

  return (
    <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
      <p className="text-sm text-blue-800">
        Showing results for: 
        {selectedState !== "All States" && ` ${selectedState}`}
        {selectedCrop !== "All Crops" && ` • ${selectedCrop}`}
        {selectedCommunity !== "All Communities" && ` • ${selectedCommunity}`}
        {filteredTopicsCount === 0 && (
          <span className="text-red-600"> • No results found</span>
        )}
      </p>
    </div>
  );
};
